export default __webpack_public_path__ + "static/media/31.3f15585f.png";